import api from 'config/api.config';
import { DashboardData } from 'types/dashboard';
import { getErrorMessage } from 'utils/errors';

/**
 * Fetch dashboard data for a specific social media account.
 * @param date_filter - The date filter for the dashboard data (e.g., 'Today', 'All data').
 * @param account_id - The ID of the social media account (optional).
 * @returns The dashboard data.
 */

export const getDashboardData = async (
  date_filter: string,
  account_id: string | null,
  options?: { start_date?: string; end_date?: string }
): Promise<DashboardData> => {
  try {
    // Calculate timezone offset in minutes
    const date = new Date();
    const timezoneOffsetMinutes = date.getTimezoneOffset(); // Offset in minutes

    const payload: Record<string, unknown> = { date_filter, account_id, timezoneOffsetMinutes };
    if (date_filter === 'Custom' && options?.start_date && options?.end_date) {
      payload.start_date = options.start_date;
      payload.end_date = options.end_date;
    }

    const response = await api.post<DashboardData>(
      '/api/dashboard',
      payload
    );

    return response.data;
  } catch (error: unknown) {
    throw new Error(getErrorMessage(error, 'Failed to fetch dashboard data'));
  }
};
